import { HTTP_STATUS_CODES } from '@@constants/http';

const errorCodes = {
    INTERNAL_SERVER_ERROR: 'Internal Server Error',
    CONSTRAINT_ERROR: 'Validation failed',
    NOT_AUTHORIZED_STATUSCODE: HTTP_STATUS_CODES.UNAUTHORIZED,
    PRECONDITION_FAILED_STATUSCODE: HTTP_STATUS_CODES.PRECONDITION_FAILED,
    BAD_REQUEST: HTTP_STATUS_CODES.BAD_REQUEST,
};

export default errorCodes;
